import { AssigneesUserAvatar } from "@app/screens/ExternalQuestionnaires/components/AssigneesUserAvatar";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useQuestionnaireStats } from "../../data";
import { CompletionChart } from "./CompletionChart";
import { GeneralInfo } from "./GeneralInfo";
import { UsersActivityChart } from "./UsersActivityChart";
import { UsersActivityModal } from "./UsersActivityModal";
import {
    defaultAiSuggestionStats,
    defaultCompletionStats,
} from "./defaultStats";
import { useQuestionnaireStatsTranslations } from "./i18n";

export const QuestionnaireStats: FC<{ questionnaireId?: string }> = ({
    questionnaireId,
}) => {
    const {
        stats: { completionStats, aiSuggestionStats, userActivityStats } = {},
    } = useQuestionnaireStats(questionnaireId);

    const { t, keys } = useQuestionnaireStatsTranslations();

    const assigneesIds = userActivityStats?.chartMetadata?.userIds;

    return (
        <FlexRow as="section" className="overflow-hidden" px="4">
            <FlexCol className="flex-1 overflow-hidden" pr="7" gap="6">
                <GeneralInfo questionnaireId={questionnaireId} />
                <CompletionChart
                    chartData={aiSuggestionStats || defaultAiSuggestionStats}
                />
                <CompletionChart
                    chartData={completionStats || defaultCompletionStats}
                />
            </FlexCol>
            {userActivityStats?.seriesConfig &&
                userActivityStats.dataRows.length > 0 && (
                    <FlexCol
                        className="flex-1 border-l border-l-tertiary  overflow-hidden"
                        gap="6"
                        pl="7"
                    >
                        <FlexCol gap="1.5">
                            <Text variant="caption-bold">
                                {t(keys.user_activity_avatars_label)}
                            </Text>
                            {assigneesIds ? (
                                <AssigneesUserAvatar
                                    userIds={new Set(assigneesIds)}
                                    truncateAfter={5}
                                />
                            ) : (
                                "-"
                            )}
                        </FlexCol>
                        <FlexCol gap="2">
                            <UsersActivityChart
                                chartData={userActivityStats}
                                truncateAfter={5}
                            />
                            {userActivityStats.dataRows.length > 5 && (
                                <UsersActivityModal
                                    chartData={userActivityStats}
                                />
                            )}
                        </FlexCol>
                    </FlexCol>
                )}
        </FlexRow>
    );
};
